import { ref} from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm} from 'vee-validate'
import { sendToSupplierSchema } from '@/schemas/batchSchema'

export const useSendToSupplierForm = (): any => {
    const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
        validationSchema: toTypedSchema(sendToSupplierSchema)
    })
    const toast = useToast()
    const loading = ref(false)
    const sendToSupplierLoading = ref(false)

    const showToast = (type: 'success' | 'error', title: string, message: string) => {
        toast.add({
            severity: type,
            summary: title,
            detail: message,
            life: 5000
        })
    }

    return { values, handleSubmit, errors, setErrors, resetForm, meta, loading, sendToSupplierLoading, showToast }
}
